module.exports = __webpack_public_path__ + "assets/iadt.0f2a68b0.svg";